import { msg } from "@lingui/core/macro";

export const expiryTimeAfterTimeRuleMessages = {
	name: msg({ message: "Expiry Time After Time" }),
	description: msg({ message: "Permit expiry time must be after time" }),
	errors: {
		noEndTime: msg({ message: "Permit must have an end time" }),
		isBefore: msg({ message: "Permit Expiry Time must be after {time}" }),
	},
} as const;
